var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEyeSlash(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax_bold_eye-slash",
    "data-name": "vuesax/bold/eye-slash",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.213,1.671a14.129,14.129,0,0,0-.92-1.29A1,1,0,0,0,10.8.291l-3,3a3.922,3.922,0,0,1,.06,2.21,4.021,4.021,0,0,1-2.9,2.9,3.922,3.922,0,0,1-2.21-.06L.293,10.8a1,1,0,0,0,.33,1.64,9.221,9.221,0,0,0,3.32.62,9.682,9.682,0,0,0,5.09-1.49,13.427,13.427,0,0,0,4.23-4.34A5.78,5.78,0,0,0,13.213,1.671Z",
    transform: "translate(8.057 7.509)",
    fill: "#292d32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M4.88.84.84,4.88A2.9,2.9,0,0,1,0,2.86,2.866,2.866,0,0,1,2.86,0,2.9,2.9,0,0,1,4.88.84Z",
    transform: "translate(9.14 9.14)",
    fill: "#292d32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M16.25,2.32,12.86,5.71A3.986,3.986,0,0,0,10,4.53a4.045,4.045,0,0,0-2.86,6.9L3.76,14.82H3.75a14.283,14.283,0,0,1-3-3.41,5.771,5.771,0,0,1,0-5.69A13.354,13.354,0,0,1,4.91,1.49,9.774,9.774,0,0,1,10,0,9.936,9.936,0,0,1,16.25,2.32Z",
    transform: "translate(2 3.43)",
    fill: "#292d32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M3.03.17A2.866,2.866,0,0,1,.17,3.03.5.5,0,0,1,0,3.01L3.01,0A.5.5,0,0,1,3.03.17Z",
    transform: "translate(11.83 11.83)",
    fill: "#292d32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-5",
    "data-name": "Vector",
    d: "M19.765.225a.773.773,0,0,0-1.09,0L.225,18.685a.773.773,0,0,0,0,1.09.791.791,0,0,0,.54.22.758.758,0,0,0,.54-.23L19.765,1.3A.743.743,0,0,0,19.765.225Z",
    transform: "translate(2.005 2.005)",
    fill: "#292d32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-6",
    "data-name": "Vector",
    d: "M0,0H24V24H0Z",
    transform: "translate(24 24) rotate(180)",
    fill: "none",
    opacity: 0
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeSlash);
export default __webpack_public_path__ + "static/media/eye-slash.6786b036d6853dfa0fbb7b76b9fdb84d.svg";
export { ForwardRef as ReactComponent };